<template>
    <div class="text-center">
        <b-pagination
        :value="page"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
        first-text="First"
        last-text="Last"
        @change="changePage"
        size="sm"
    ></b-pagination>
    </div>
</template>

<script>
export default {
  data () {
    return {
      perPage: process.env.VUE_APP_NUMBER_PER_PAGE
    };
  },
  props: {
    totalRows: Number,
    page: Number
  },
  methods: {
    changePage (e) {
      this.$emit('changePage', e);
    }
  }
};
</script>

<style>
    .page-item.active .page-link{
        background-color: #999999;
        border-color:aliceblue;
    }
    .page-link{
        color: #666666;
    }
</style>
